<div class="text-center font-weight-bold" style="font-size: 22px">
  Authenticating <span class="fa fa-spinner fa-spin"></span>
</div>
